import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';

const Context = React.createContext();

export const CommunicationGroupsProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();

    const selectRecord = useCallback(async (props) => {
        await execute({ scope: 'select', url: `CommunicationGroup/${props.communicationGroupId}`, method: 'GET', secure: true });
    }, [execute]);

    const newRecord = useCallback(async (props) => {
        await execute({ scope: 'new', payload: { status: 200, body: props } });
    }, [execute]);

    const createRecord = useCallback(async (props) => {
        await execute({ scope: 'create', url: `CommunicationGroup`, method: 'POST', payload: props, secure: true });
    }, [execute]);

    const updateRecord = useCallback(async (props) => {
        await execute({ scope: 'update', url: `CommunicationGroup/${props.communicationGroupId}`, method: 'PUT', payload: props, secure: true });
    }, [execute]);

    const listRecords = useCallback(async () => {
        let url = 'CommunicationGroup';
        await execute({ scope: 'list', url: url, method: 'GET', secure: true });
    }, [execute]);

    const listCommunicationGroupsWithAdminAdded = useCallback(async () => {
        let url = 'CommunicationGroup/GettAllWithAdminAdded';
        await execute({ scope: 'listCommunicationGroups', url: url, method: 'GET', secure: true });
    }, [execute]);

    const deleteRecord = useCallback(async (props) => {
        await execute({ scope: 'delete', url: `CommunicationGroup/${props.communicationGroupId}`, method: 'DELETE', secure: true });
    }, [execute]);

    const value = { selectRecord, listRecords, listCommunicationGroupsWithAdminAdded, newRecord, deleteRecord, updateRecord, createRecord, data, clearData };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useCommunicationGroupStore = () => React.useContext(Context);
